<div class="grid">

    <div class="col-12">

        <!-- <p-card header="Incomplete Enrollments - Details" subheader="" class="tile" > -->

        <p-card subheader="" class="wal-tile">

            <ng-template pTemplate="header">
                <div class="custom-card-header">
                    <div class="header-text">Incomplete Enrollment Stages</div>

                    @if(isSummaryShown) {
                        <div class="header-totals">
                            <span class="total-badge">Total Attempts: {{ totalEnrollmentAttemptCnt }}</span>
                            <span class="total-badge">Total Rendered: {{ totalPassRenderedCnt }}</span>
                            <span class="total-badge">Total Registered: {{ totalRegisteredCnt }}</span>
                        </div>
                    }                    
                </div>

            </ng-template>

            <!--  G R I D  -->

            @if(isSummaryShown) {
                <div class="ng-template w-full">

                    <div class="grid">

                        <div class="col-7">

                            <p-table #dtt [columns]="summaryColumns" [value]="summaryRows" selectionMode="single"
                                class="wal-table"
                                tableStyleClass="prime-table" [rowsPerPageOptions]="[10,15,25,50]" [showCurrentPageReport]="true"
                                sortMode="multiple" [paginator]="true" [rows]="15">
                                <ng-template pTemplate="caption">
                                Incomplete Enrollment Events by Source Channel and Platform
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                <tr>
                                @for (col of columns; track col.field) {
                                    <th [pSortableColumn]="col.field"
                                        [style.display]="col.display"
                                        [style.width]="col.width">
                                        {{ col.header }}
                                        <p-sortIcon [field]="col.field"></p-sortIcon>
                                    </th>
                                }
                                </tr>
                                </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr [pSelectableRow]="rowData">
                                        @for (col of columns; track col.field) {
                                            <td [style.width]="col.width" [style.display]="col.display">
                                                {{ rowData[col.field] }}
                                            </td>
                                        }
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <div style="text-align:left">
                                        <p-button type="button" label="CSV Export"
                                            styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="dtt.exportCSV()">
                                        </p-button>
                                        <p-button type="button" label="PDF Export"
                                            styleClass="p-button-warning p-button-raised p-button-rounded margin-left" (click)="exportToPdf()">
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-table>

                        </div>

                        <!-- <div class="col-1"></div> -->

                        <div class="col-4 chart-col">
                            @if(tabValue === 'Summary' && hasData) {

                                @defer (on viewport) {
                                    <p-chart [type]="selectedChartType"
                                        #chart
                                        [data]="chartData"
                                        [options]="chartOptions"
                                        class="wal-chart-container">
                                    </p-chart>
                                } @placeholder {
                                    <div>Loading chart...</div>
                                } @error {
                                    <p>Failed to load the chart.</p>
                                }

                            }
                        </div>
                    </div>

                </div>
            }

            @if(isDetailsShown) {
                <div class="ng-template w-full">

                    <div class="p-datatable p-component">

                        <div class="p-datatable-header">
                            <div class="header-row">
                            <div class="wal-page-title">Incomplete Enrollments Details</div>
                            </div>
                        </div>

                        <div class="p-datatable-wrapper">

                            <!-- Column headers with sorting -->
                            <div class="thead row-grid">
                                <div class="th clickable" (click)="toggleSort('sessionId')">
                                    Event ID <span>{{ sortField === 'sessionId' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('originationType')">
                                    Origination Type <span>{{ sortField === 'originationType' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('srcChannel')">
                                    Source Channel <span>{{ sortField === 'srcChannel' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('platform')">
                                    Platform <span>{{ sortField === 'platform' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('accountNo')">
                                    Account Number <span>{{ sortField === 'accountNo' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('enrollmentAttemptDate')">
                                    Enrollment Attempt Date <span>{{ sortField === 'enrollmentAttemptDate' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('passRenderedDt')">
                                    Pass Rendered Date <span>{{ sortField === 'passRenderedDt' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                            </div>

                            <!-- Scrollable viewport -->
                            <div class="tbody-viewport">
                                @if (datasource) {
                                    <!-- Virtualized rows -->
                                    <div
                                    class="tr row-grid"
                                    *uiScroll="let row of datasource; let even = even"
                                    (click)="onRowClick(row)"
                                    [class.even]="even"
                                    [class.selected]="isSelected(row)"
                                    >
                                    <div class="td">{{ row.sessionId }}</div>
                                    <div class="td">{{ row.originationType }}</div>
                                    <div class="td">{{ row.srcChannel }}</div>
                                    <div class="td">{{ row.platform }}</div>
                                    <div class="td">{{ row.accountNo }}</div>
                                    <div class="td">{{ row.enrollmentAttemptDate }}</div>
                                    <div class="td">{{ row.passRenderedDt }}</div>
                                    </div>
                                }
                            </div>

                        </div>

                        <div class="p-datatable-footer p-text-secondary">
                        </div>

                    </div>

                </div>
            }

        </p-card>

    </div>

</div>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="client-dashboard-warning"></p-confirmDialog>